import { C } from '../constants/dashboardConstants';
import { resizedImageUrl } from '../utils/imageUrl';

// 이름마다 고정된 색이 나오도록 — 새로고침해도 색이 바뀌지 않는다
const COLORS = ['#7F77DD', '#D4537E', '#1D9E75', '#BA7517', '#185FA5', '#993556', '#0F6E56', '#993C1D'];

const hashOf = (str) => {
  let h = 0;
  for (let i = 0; i < str.length; i += 1) h = (h * 31 + str.charCodeAt(i)) | 0;
  return Math.abs(h);
};

/** 한글은 2글자, 영문은 이니셜 2자 */
const initialsOf = (name) => {
  const v = String(name ?? '').trim();
  if (!v) return '';
  if (/^[A-Za-z]/.test(v)) {
    return v.split(/\s+/).slice(0, 2).map(w => w[0]).join('').toUpperCase();
  }
  return v.slice(0, 2);
};

/**
 * 대화 상대 아바타.
 * 사진이 없을 때 모두에게 같은 아이콘을 띄우면 누가 누군지 구분되지 않으므로
 * 이름 이니셜 + 이름 기반 고정 색으로 대체한다.
 */
export default function Avatar({ url, name, size = 50 }) {
  const initials = initialsOf(name);
  const color = COLORS[hashOf(String(name ?? '')) % COLORS.length];

  return (
    <div
      aria-hidden="true"
      data-testid="avatar"
      data-has-photo={url ? 'true' : 'false'}
      style={{
        width: size, height: size, borderRadius: '50%', flexShrink: 0, overflow: 'hidden',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        background: url ? C.g200 : `${color}22`,
      }}
    >
      {url ? (
        <img
          src={resizedImageUrl(url, 'thumb') ?? url}
          alt=""
          loading="lazy"
          decoding="async"
          // 리사이즈본은 Lambda 비동기 처리라 아직 없을 수 있다 → 원본으로 물러난다
          onError={(e) => { if (e.target.src !== url) e.target.src = url; }}
          style={{ width: '100%', height: '100%', objectFit: 'cover' }}
        />
      ) : initials ? (
        <span style={{
          fontFamily: 'Pretendard, sans-serif',
          fontSize: Math.round(size * 0.36),
          fontWeight: 700,
          color,
          letterSpacing: '-0.04em',
        }}>
          {initials}
        </span>
      ) : (
        <svg width={size * 0.5} height={size * 0.5} viewBox="0 0 24 24" fill="none">
          <circle cx="12" cy="8" r="4" stroke={C.sub} strokeWidth="2" />
          <path d="M4 20c0-4 3.6-7 8-7s8 3 8 7" stroke={C.sub} strokeWidth="2" strokeLinecap="round" />
        </svg>
      )}
    </div>
  );
}
